import { render, staticRenderFns } from "./LogoutComponent.vue?vue&type=template&id=814235f8"
import script from "./LogoutComponent.vue?vue&type=script&lang=js"
export * from "./LogoutComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports